import { getCustomerOnboardingIncompleteStepRoute } from "components/Screens/CustomerOnboarding/helpers";

import NavigationRoutes from "constants/NavigationRoutes";
import { USER_TYPES } from "constants";
import { consumeIntendedRoute, withCampaignParams } from "util/postLoginRedirect";

export const getUserInfoRequest = (loggedInUser) => {
  const { type, customerId, userId } = loggedInUser || {};
  if (type === "customer") {
    return `customer/${customerId}/info`;
  }
  if (type === "edge") {
    return `user/${userId}/summary`;
  }
  if (type === "employee") {
    return `employee/${userId}`;
  }
  return "";
};

export const handlePostLoginNavigation = (
  loggedInUser,
  additionalInfo,
  navigate,
  integratedContractSigning = false,
  { restoreIntendedRoute = true } = {}
) => {
  if (!loggedInUser || !loggedInUser.type) {
    return;
  }
  const { type, bankAttached } = loggedInUser;

  if (!Object.values(USER_TYPES).includes(type)) {
    return;
  }

  // Consumed unconditionally, here, near the top: the earlier returns bail before navigating, so
  // consuming there would silently discard a saved deep link, and consuming it now - win or lose
  // the onboarding/addPaymentMethod rungs below - means it can never go stale across a later login.
  // When restoreIntendedRoute is false (password reset is out of scope for this redirect), the
  // value is discarded rather than left stored, preserving the single-use invariant so it can't
  // resurface for a later sign-in.
  const consumedRoute = consumeIntendedRoute();
  const savedRoute = restoreIntendedRoute ? consumedRoute : null;

  if (type !== USER_TYPES.CUSTOMER) {
    navigate(withCampaignParams(savedRoute ?? NavigationRoutes.dashboard));
    return;
  }

  if (integratedContractSigning) {
    const { onboardingProgress = {} } = additionalInfo || {};
    const incompleteStepRoute = getCustomerOnboardingIncompleteStepRoute(onboardingProgress);

    if (incompleteStepRoute) {
      navigate(withCampaignParams(incompleteStepRoute));
      return;
    }
  }

  if (!bankAttached && additionalInfo?.status === "enabled") {
    navigate(withCampaignParams(NavigationRoutes.addPaymentMethod));
    return;
  }

  navigate(withCampaignParams(savedRoute ?? NavigationRoutes.dashboard));
};

export const getAuthenticationError = (errorList) => {
  if (errorList != null && errorList != undefined) {
    return errorList.map((error) => (
      <div key={error?.msg || error?.description || Math.random()} className="para-body-m-regular">
        {error?.msg || error?.description || "Something went wrong"}
      </div>
    ));
  }
  return null;
};
